module.exports = __webpack_public_path__ + "static/media/avatar-5.df0e7e87.png";